import {PlusOutlined} from '@ant-design/icons'
import {Button, Divider, Input, Select, Space, Typography} from "antd"
import classnames from "classnames"
import _ from 'lodash'
import useTranslate from "modules/local/useTranslate"
import React, {useCallback, useEffect, useRef, useState} from "react"
import {AiOutlineGlobal, AiOutlineLink} from "react-icons/ai"
import {BsFacebook, BsLinkedin, BsTwitter} from "react-icons/bs"
import {NullAsDefault, renderIf} from "../../../Shared";
import {IoChevronDown} from "react-icons/io5";
import {HiMinus, HiPlus} from "react-icons/hi2";

const LinkedOptions = Object.freeze({
    FACEBOOK: 'Facebook',
    LINKED_IN: 'Linkedin',
    TWITTER: 'Twitter',
    // WEBSITE: 'website'
})

const availablePages = [
    LinkedOptions.FACEBOOK,
    LinkedOptions.LINKED_IN,
    LinkedOptions.TWITTER,
    // LinkedOptions.WEBSITE,
]

const fromPage = page => {
    switch (page) {
        case LinkedOptions.FACEBOOK:
            return {
                inputPlaceholder: 'FB url...'
            }
        case LinkedOptions.LINKED_IN:
            return {
                inputPlaceholder: 'LinkedIn url...'
            }
        case LinkedOptions.TWITTER:
            return {
                inputPlaceholder: 'Twitter url...'
            }
        default:
            return {}
    }
}


export const getPageIcon = page => {
    switch (page) {
        case LinkedOptions.FACEBOOK:
            return <BsFacebook/>
        case LinkedOptions.LINKED_IN:
            return <BsLinkedin/>
        case LinkedOptions.TWITTER:
            return <BsTwitter/>
        case "website":
            return <AiOutlineGlobal/>
        default:
            return <AiOutlineLink/>
    }
}

export const sampleData = [
    {
        page: LinkedOptions.FACEBOOK,
        url: 'https://wwww.facebook.com/'
    },
    {
        page: LinkedOptions.LINKED_IN,
        url: 'https://www.linkedin.com/'
    },
    {
        page: LinkedOptions.TWITTER,
        url: 'https://twitter.com/'
    }
]

const getDefaultPages = ([key, value]) => {
    return availablePages.map(e => {
        return {
            [key]: e,
            [value]: ''
        }
    })
}

const mergePages = (pages, [key, value]) => {
    const keys = pages.map(e => _.get(e, key))
    const union = _.union(availablePages, keys)
    return union.map(page => {
        const current = _.find(
            pages,
            e => _.isEqual(page, _.get(e, key)),
        )
        return {
            [key]: page,
            [value]: _.get(
                current,
                value,
                '',
            )
        }
    })
}

function mapPages(pages, [name, value]) {
    return pages.map(
        item => ({
            [name]: item[name],
            [value]: item[value]
        })
    )
}

const RenderDropdown = menu => {
    const t = useTranslate()
    return (
        <>
            {menu}
            <Divider className="my-1"/>
            <div className="flex px-2 py-1">
                <Input
                    // onBlur={e => {
                    //   setOther('')
                    // }}
                    // onPressEnter={e => {
                    //   addOther(other)
                    // }}
                    // onChange={e => {
                    //   setOther(e.target.value)
                    // }}
                    // value={other}
                    placeholder={t('others')}/>
                <Typography.Link
                    className="px-2 my-auto"
                    // onClick={() => {
                    //   addOther(other)
                    // }}
                    style={{whiteSpace: 'nowrap'}}>
                    <PlusOutlined/> {t('add')}
                </Typography.Link>
            </div>
        </>
    )
}

const RenderChildOnly = ({children}) => (children)

const WithChild = props => Child => {
    return (
        <Child {...props} />
    )
}

const NewPageItem = ({
                         className,
                         filterOption,
                         onClick = NullAsDefault,
                         options = [],
                         ...props
                     }) => {

    const [value, setValue] = useState(null)

    const t = useTranslate()

    const buttonStyle = {
        width: '46px'
    }

    const newLine = value => {
        onClick(value)
    }


    return (
        <Space.Compact style={{rowGap: 0}} className={className}>
            <Select
                {...{
                    showSearch: true,
                    defaultValue: value,
                    notFoundContent: t('press enter to create new page'),
                    optionFilterProp: "children",
                    onChange: val => {
                        setValue(val)
                    },
                    onSearch: val => {
                        setValue(val)
                    },
                    onSelect: page => {
                        newLine(page)
                    },
                    onInputKeyDown: e => {
                        if (e.key === 'Enter') {
                            const {value} = e.target
                            newLine(value)
                        }
                    },
                    filterOption: filterOption,
                    children: options.map((page) => {
                        return (
                            <Select.Option
                                key={page}
                                value={page}>
                                {page}
                            </Select.Option>
                        )
                    }),
                    placeholder: t('add new page'),
                    suffixIcon: <IoChevronDown className="text-color-200"/>,
                    style: {
                        width: `calc(100% - ${buttonStyle.width})`
                    },
                }}
            />
            <Button
                color="primary" variant="solid"
                disabled={_.isEmpty(value)}
                style={buttonStyle}
                icon={<HiPlus size={15}/>}
                onClick={() => {
                    newLine(value)
                }}
                className="flex flex-center"
            />
        </Space.Compact>
    )
}

const LinkedPages = ({
                         fieldName = 'page',
                         fieldValue = 'url',
                         data = [],
                         onChange = NullAsDefault,
                         onSearch = NullAsDefault,
                         getPages = mapPages,
                         classNames = [],
                         renderPrimary = WithChild,
                         renderSecondary = WithChild,
                         renderWrapper = RenderChildOnly
                     }) => {

    const t = useTranslate()

    const fields = [fieldName, fieldValue]

    // `data` là Formik value ở form Sửa Khóa học (CourseSetForm.js) - có thể là undefined/null/chuỗi
    // JSON tuỳ nguồn, chuẩn hoá về mảng trước khi map để getPages không gọi .map trên non-array.
    const safeData = Array.isArray(data) ? data : []

    const defaultValues = getPages(safeData, fields)

    const filterOption = (input, {children}) => {
        const left = children.toLowerCase()
        const right = input.toLowerCase()
        return left.indexOf(right) >= 0
    }

    const [currentPages, setPages] = useState(() => getPages(safeData, fields))

    const [autoFocus, setAutoFocus] = useState(false)

    // Đồng bộ lại danh sách nội bộ CHỈ KHI nội dung `data` từ ngoài thực sự đổi (so bằng chuỗi hoá).
    // Bản cũ dùng cặp state isReady + so sánh với `defaultValues` (mảng tạo mới mỗi lần render) ngay
    // trong useEffect: khi component cha reinit liên tục (Formik enableReinitialize ở EditCourseModal
    // của tab "Cấu hình Khóa học") thì effect setState qua lại không hội tụ -> "Maximum update depth
    // exceeded". Dùng ref giữ key đã sync, effect không thể tự kích hoạt lại chính nó.
    const dataKey = JSON.stringify(defaultValues)
    const lastSyncedKeyRef = useRef(dataKey)

    useEffect(() => {
        if (lastSyncedKeyRef.current === dataKey) return
        lastSyncedKeyRef.current = dataKey
        setPages(getPages(safeData, fields))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKey])

    const existingPage = page => {
        return _.find(
            currentPages,
            e => _.isEqual(e.page, page),
        )
    }

    const addOther = page => {
        if (_.isEmpty(page)) {
            return
        }
        if (!existingPage(page)) {
            const newPages = [
                ...currentPages,
                {
                    [fieldName]: page,
                    [fieldValue]: ''
                }
            ]
            setPages(newPages)
            setAutoFocus(true)
        }
    }

    const remove = page => {
        if (existingPage(page)) {
            const newPages = [...currentPages]
            const index = _.findIndex(
                newPages,
                e => _.isEqual(e.page, page)
            )
            newPages.splice(index, 1)
            const rest = [...newPages]
            setPages(rest)
            onChange(rest)
        }
    }

    const handleChange = (target, item) => {
        let newPages = currentPages
        const {page, value} = item

        if (target === fieldName) {
            if (existingPage(page)) {
                newPages = newPages.map(e => {
                    return _.isEqual(e.page, page)
                        ? {
                            [fieldName]: value,
                            [fieldValue]: e.url,
                        }
                        : e
                })
            } else {
                newPages = [
                    ...newPages,
                    {
                        [fieldName]: page,
                        [fieldValue]: '',
                    }
                ]
            }

        } else if (target === fieldValue) {
            // const error = !!!_.startsWith('http', value)
            newPages = newPages.map(e => {
                return _.isEqual(e.page, page)
                    ? {
                        [fieldName]: e.page,
                        [fieldValue]: value,
                    }
                    : e
            })
        }

        setPages(newPages)
        onChange(newPages)
    }

    const Wrapper = useCallback(props => {
        return renderWrapper({
            ...props
        })
    }, [])

    const [pageClassName, urlClassName] = classNames

    const removeButtonStyle = {
        width: '46px'
    }

    const isNewLine = page => {
        return !_.includes(currentPages, page)
    }

    const hasError = page => {
        const error = _.get(existingPage(page), 'error')
        return error ? 'error' : null
    }


    return (
        <Wrapper>
            {(currentPages || defaultValues).map((item, index) => {
                const page = _.get(item, fieldName)
                const url = _.get(item, fieldValue)

                const newLine = isNewLine(page)

                const {inputPlaceholder} = fromPage(page)

                return (
                    <div
                        key={index}
                        className={classnames(pageClassName)}>
                        {renderPrimary({
                            showSearch: true,
                            defaultValue: page,
                            notFoundContent: '',
                            suffixIcon: <IoChevronDown className="text-color-300"/>,
                            placeholder: t('select page'),
                            optionFilterProp: "children",
                            onChange: value => {
                                handleChange(
                                    fieldName, {
                                        page,
                                        value
                                    })
                            },
                            onInputKeyDown: e => {
                                if (e.key === 'Enter') {
                                    const {value} = e.target
                                    addOther(value)
                                }
                            },
                            onSearch: onSearch,
                            filterOption: filterOption,
                            children: availablePages
                                .filter(e => !existingPage(e))
                                .map((page) => {
                                    return (
                                        <Select.Option
                                            key={page}
                                            value={page}>
                                            {page}
                                        </Select.Option>
                                    )
                                })
                        })(Select)}
                        <Space.Compact style={{rowGap: 0}} className={classnames('flex-1', urlClassName)}>
                            {renderSecondary({
                                // Trước đây key/disabled buộc vào state isReady để ép Input mount lại
                                // sau lần sync đầu (currentPages khởi tạo rỗng). Nay currentPages được
                                // khởi tạo thẳng từ data ngay lần render đầu nên bỏ được hack này.
                                defaultValue: url,
                                allowClear: true,
                                autoFocus: autoFocus,
                                status: hasError(page),
                                placeholder: inputPlaceholder,
                                onChange: e => {
                                    handleChange(
                                        fieldValue, {
                                            page,
                                            value: e.target.value
                                        })
                                },
                                ...newLine
                                    ? {
                                        style: {
                                            width: `calc(100% - ${removeButtonStyle.width})`
                                        }
                                    }
                                    : {},
                            })(Input)}
                            {renderIf(
                                newLine,
                                <Button
                                    color="primary" variant="solid"
                                    style={removeButtonStyle}
                                    icon={<HiMinus size={15} />}
                                    onClick={() => {
                                        remove(page)
                                    }}
                                />
                            )}
                        </Space.Compact>
                    </div>
                )
            })}
            <NewPageItem
                key={(currentPages || []).length}
                onClick={addOther}
                options={
                    availablePages.filter(e => {
                        return !existingPage(e)
                    })
                }
                filterOption={filterOption}
            />
        </Wrapper>
    )
}

export default LinkedPages